// extracted by mini-css-extract-plugin
export var label = "_ja-0";
export var treatmentCard = "_ja-1";